import React, { useEffect, Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
// Below-the-fold sections are code-split so the initial load only ships/renders
// the Hero. Each chunk is fetched on demand, dramatically lowering the JS that
// must be parsed and executed before the page becomes interactive.
const StatsBar = lazy(() => import('./components/StatsBar').then(m => ({
  default: m.StatsBar
})));
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const ProductHero = lazy(() => import('./components/ProductHero').then(m => ({
  default: m.ProductHero
})));
const TomosGrid = lazy(() => import('./components/TomosGrid').then(m => ({
  default: m.TomosGrid
})));
const BonosSection = lazy(() => import('./components/BonosSection').then(m => ({
  default: m.BonosSection
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const Comparison = lazy(() => import('./components/Comparison').then(m => ({
  default: m.Comparison
})));
const ExtendedTestimonials = lazy(() => import('./components/ExtendedTestimonials').then(m => ({
  default: m.ExtendedTestimonials
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
const FB_PIXEL_ID = '1735933241090046';
// Lightweight placeholder that reserves vertical space to minimise layout shift
// while a lazy section streams in.
function SectionFallback() {
  return <div className="w-full min-h-[40vh]" aria-hidden="true" data-id="element-0" data-mp="3ubzrw5cgz9c0" />;
}
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as any;
    if (w.fbq) return;
    try {
      // Define the fbq stub + queue so calls work even before the script loads
      const n: any = w.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Inject the external script defensively (head append, swallow load errors)
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onerror = () => {
        /* cross-origin / blocked load — ignore so the app never crashes */
      };
      (document.head || document.documentElement).appendChild(script);
      w.fbq('init', FB_PIXEL_ID);
      w.fbq('track', 'PageView');
    } catch {
      /* never let analytics break the page */
    }
  }, []);
  return <div className="min-h-screen w-full bg-ink font-sans text-white selection:bg-gold selection:text-ink" data-id="element-1" data-mp="ydik298ahdu7">
      <main data-id="element-2" data-mp="13cbvlw40murq">
        <Hero data-id="element-3" data-mp="1r4969jvqbgr9" />
        <Suspense fallback={<SectionFallback data-id="element-5" data-mp="1r5alm0js2pes" />} data-id="element-4" data-mp="1r3r64c5y4ie2">
          <StatsBar data-id="element-6" data-mp="1r52aad3azs5p" />
          <SocialProof data-id="element-7" data-mp="1w3c2qfxn8enm" />
          <PainSection data-id="element-8" data-mp="1w3vl1xr7h526" />
          <ProductHero data-id="element-9" data-mp="1w210wlnrdgz5" />
          <TomosGrid data-id="element-10" data-mp="1w2kg3um0xr9h" />
          <BonosSection data-id="element-11" data-mp="1i3kvcy1mtwil" />
          <Pricing data-id="element-12" data-mp="1i4ceh9e1m1rz" />
          <Comparison data-id="element-13" data-mp="1i2swnecqnio3" />
          <ExtendedTestimonials data-id="element-14" data-mp="1i3b4l88rjlbu" />
          <Guarantee data-id="element-15" data-mp="1m4wa28iywxc0" />
          <FAQ data-id="element-16" data-mp="1m4ehblvil18u" />
          <FinalCTA data-id="element-17" data-mp="1m3uxfzmb02s6" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-18" data-mp="6ofemq4o1xfz">
        <Footer data-id="element-19" data-mp="6ncmyfzirqz0" />
        <PurchasePopup data-id="element-20" data-mp="6muiwx6m88gj" />
      </Suspense>
    </div>;
}